import { useQpmMonitorSupplierMutation } from "@/services/backend/qpm/monitors/api/monitor-api";
import { Label } from "@/shared/components/ui/label";
import { Input } from "@/shared/components/ui/input";

export function MonitorSupplierComponent({
  monitorId,
  value,
  disabled,
}: {
  monitorId: string;
  value: string;
  disabled?: boolean;
}) {
  const [update] = useQpmMonitorSupplierMutation();

  return (
    <div className="grid grid-cols-4 items-center gap-1.5">
      <Label className="col-span-2" htmlFor="supplier">
        Lieferant
      </Label>
      <Input
        className="col-span-2"
        id="supplier"
        type="text"
        defaultValue={value}
        disabled={disabled}
        onBlur={(e) => {
          if (disabled) return;
          update({ id: monitorId, supplier: e.target.value });
        }}
      />
    </div>
  );
}
